import "./page404.css";

const Page404 = () => {
  return (
    <>
      <div className="page-404">
        <div>
          <h2>Page is not found.</h2>
          <h4>
            Return to <a href="/">Home page</a>.
          </h4>
        </div>
      </div>
    </>
  );
};

export default Page404;
